import { createFileRoute } from '@tanstack/react-router';

import OfficeAuthCallbackScreen from '@/screens/office/auth-callback';

/** Where the add-in's login dialog returns to, and hands the code to the pane (KAN-1766). */
export const Route = createFileRoute('/office/auth-callback')({
  component: OfficeAuthCallbackScreen,
});
